import { Injectable, Output, EventEmitter, Injector } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CategoryData } from '../models/DoughtnutDetails';

@Injectable({ providedIn: 'root' })
export class MessageService {
    public subj = new Subject<any>();
    loadHeader(arg0: number): any {
        this.subj.next(arg0);
    }
    public subjViewDetails = new Subject<any>();
    loadViewDetails(arg0: boolean): any {
        this.subjViewDetails.next(arg0);
    }
    private navigateToAttributeMapTab = new BehaviorSubject<boolean>(false);
    currentNavigateToAttributeMapTab = this.navigateToAttributeMapTab.asObservable();
    private navigateToCreateDDTab = new BehaviorSubject<boolean>(false);
    currentNavigateToCreateDDTab = this.navigateToCreateDDTab.asObservable();
    private navigateToExcelUploadTab = new BehaviorSubject<boolean>(false);
    currentNavigateToExcelUploadTab = this.navigateToExcelUploadTab.asObservable();
    private proposalIdInScopeSelector = new BehaviorSubject<number>(0);
    currentProposalIdInScopeSelector = this.proposalIdInScopeSelector.asObservable();
    private VersionId = new BehaviorSubject<number>(0);
    currentVersionId = this.VersionId.asObservable();
    private DDName = new BehaviorSubject<string>(null);
    currentDDName = this.DDName.asObservable();
    private ProposalId = new BehaviorSubject<number>(0);
    currentProposalId = this.ProposalId.asObservable();
    private CategoryInfo = new BehaviorSubject<CategoryData>(null);
    currentCategoryInfo = this.CategoryInfo.asObservable();
    private SubcategoryId = new BehaviorSubject<number>(0);
    currentSubcategoryId = this.SubcategoryId.asObservable();
    private DDredirection = new BehaviorSubject<string>(null);
    currentDDredirection = this.DDredirection.asObservable();
    private BAUploadedData = new BehaviorSubject<Uint8Array>(null);
    currentBAUploadedData = this.BAUploadedData.asObservable();
    // private mandatCreateProposal = new BehaviorSubject<boolean>(false);
    // currentMandatCreateProposal = this.mandatCreateProposal.asObservable();
    constructor(private injector: Injector) {
    }
    updateNavigateToAttributeMapTab(message: boolean) {
        this.navigateToAttributeMapTab.next(message);
    }
    updateNavigateToCreateDDTab(message: boolean) {
        this.navigateToCreateDDTab.next(message);
    }
    updateNavigateToExcelUploadTab(message: boolean) {
        this.navigateToExcelUploadTab.next(message);
    }
    updateProposalIdInScopeSelector(message: number) {
        this.proposalIdInScopeSelector.next(message);
    }
    updateVersionId(message: number) {
        this.VersionId.next(message);
    }
    updateCategoryInfo(message: CategoryData) {
        this.CategoryInfo.next(message);
    }
    updateSubcategoryId(message: number) {
        this.SubcategoryId.next(message);
    }
    updateDDName(message: string) {
        this.DDName.next(message);
    }
    updateDDredirection(message: string) {
        this.DDredirection.next(message);
    }
    updateBAUploadedData(message: Uint8Array) {
        this.BAUploadedData.next(message);
    }
} 